import * as React from 'react';
import { Dialog, DialogType} from '@fluentui/react';
import { DefaultButton } from '@fluentui/react';
import { getId } from '@fluentui/react';
import { hiddenContentStyle, mergeStyles } from '@fluentui/react';
import { ContextualMenu } from '@fluentui/react';
import { connect } from "react-redux";
import {setGeoChoice} from "../../../actions/CreateSiteActions/dimensionActions";


const screenReaderOnly = mergeStyles(hiddenContentStyle);

export interface IDialogBasicExampleState {
    hideDialog: boolean;
    isDraggable: boolean;
}

class NewModal extends React.Component<{}, IDialogBasicExampleState> {
     state: IDialogBasicExampleState = {
        hideDialog: true,
        isDraggable: false,
        isPickerDisabled: false
    };
    // Use getId() to ensure that the IDs are unique on the page.
    // (It's also okay to use plain strings without getId() and manually ensure uniqueness.)
     _labelId: string = getId('dialogLabel');
     _subTextId: string = getId('subTextLabel');
     _dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };

    componentDidMount(): void {
        if(this.props.Created === false)
        {
            this.setState({reuse:true})
        }
    }
    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS): void {

        if(this.props.selection !== prevProps.selection)
            this._closeDialog();

    }

     render() {
        const { hideDialog} = this.state;
        const dialog =  <Dialog
            hidden={hideDialog}
            onDismiss={this._closeDialog}
            dialogContentProps={{
                type: DialogType.normal,
                title: this.props.title
            }}
            modalProps={{
                titleAriaId: this._labelId,
                subtitleAriaId: this._subTextId,
                isBlocking: false,
                dragOptions: true
            }}
            minWidth={400}
            maxWidth={600}
        >
            {this.props.component}
        </Dialog>
        return (
            <div>
                <DefaultButton 
                    secondaryText="Opens the Sample Dialog" 
                    onClick={this._showDialog} 
                    text="Select"
                    disabled={this.props.isPickerDisabled} 
                />
                <label id={this._labelId} className={screenReaderOnly}>
                    My sample Label
                </label>
                <label id={this._subTextId} className={screenReaderOnly}>
                    My Sample description
                </label>

              {dialog}
            </div>
        );
    }

     _showDialog = (): void => {
        this.setState({ hideDialog: false });
        // this.props.setGeography({key : "", name : ""});
    };

     _closeDialog = (): void => {
        this.setState({ hideDialog: true });
    };

}

const mapActionToProp = {
    setGeography: setGeoChoice
}

const mapStateToProps = state => ({
    selectedGeo: state.newSite.geography,
    possibleWarning: state.wizard.nextStepRequested,
    isIATU: state.newSite.isIATU,
    isIAPCP: state.newSite.isIAPCP,
})


export default connect(mapStateToProps, mapActionToProp)(NewModal)



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/NewModal.js